const BASE_URL = process.env.REACT_APP_APPS_SCRIPT_URL;

async function request(body) {
  const res = await fetch(BASE_URL, {
    method: 'POST',
    redirect: 'follow',
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`API error ${res.status}`);
  return res.json();
}

export const getMustardLogs = () => request({ action: 'getMustardLogs' });
export const saveMustardBatch = (data) => request({ action: 'saveMustardBatch', data });
export const fileMustardBatch = (batchId) => request({ action: 'fileMustardBatch', batchId });
export const deleteMustardBatch = (batchId) => request({ action: 'deleteMustardBatch', batchId });
export const getGarlicDipLogs = () => request({ action: 'getGarlicDipLogs' });
export const saveGarlicDipBatch = (data) => request({ action: 'saveGarlicDipBatch', data });
export const fileGarlicDipBatch = (batchId) => request({ action: 'fileGarlicDipBatch', batchId });
export const deleteGarlicDipBatch = (batchId) => request({ action: 'deleteGarlicDipBatch', batchId });
